/**
 * El dominio de la ficha anónima sirve UNA sola cosa: `/p/<token>`.
 *
 * El dominio apunta al mismo frontend que la web pública, así que cualquier otra ruta
 * —empezando por la raíz— le mostraba al cliente la home de Imperium con toda la marca.
 * Bastaba con borrar el path o tocar el logo para saber de qué inmobiliaria era la
 * propiedad, que es justo lo que el link ciego evita.
 *
 * Se ejecuta ANTES de montar React, en el entry point: así no alcanza a pintarse nada
 * de Imperium ni por un instante, y cubre todas las rutas (públicas y del CRM) sin
 * depender del router.
 */
/**
 * `ficha.boostercrm.app` es el dominio actual: el cliente que recibía el link veía la
 * palabra "oculto" en la URL y quedaba como si le mandaran algo escondido (sugerencia
 * de Daniel Viera, 03/08/2026). `ocultoinmueble.com` queda porque los links que ya se
 * repartieron por WhatsApp siguen entrando por ahí — mismo token, misma ficha.
 */
const BLIND_HOSTS = ['ficha.boostercrm.app', 'ocultoinmueble.com', 'www.ocultoinmueble.com'];

/** Marca de producto, no de inmobiliaria: no revela quién publica el inmueble. */
const FALLBACK_URL = 'https://boostercrm.app';

export function enforceBlindHost(): void {
  if (typeof window === 'undefined') return;
  if (!BLIND_HOSTS.includes(window.location.hostname.toLowerCase())) return;
  if (window.location.pathname.startsWith('/p/')) return;
  // replace y no assign: que el "atrás" no lo devuelva a una pantalla de Imperium.
  window.location.replace(FALLBACK_URL);
}
